import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Ag1BadgeBaseComponent } from '../ag1-badge-base/ag1-badge-base.component';
import { NgClass } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
@Component({
  selector: 'ag1-badge',
  templateUrl: './ag1-badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, AngularSvgIconModule],
})
export class Ag1BadgeComponent extends Ag1BadgeBaseComponent {}
